export const dimensions = {
  maxWidth: {
    main: '1262px',
    header: '1440px',
    sectionTitle: '650px',
  },
  breakpoints: {
    xs: '640px',
    sm: '768px',
    md: '1024px',
    lg: '1280px',
    xl: '1536px',
  },
  breakpointsMobile: {
    xs: '639px',
    sm: '767px',
    md: '1023px',
    lg: '1279px',
    xl: '1535px',
  },
};
